export default __webpack_public_path__ + "static/media/team-photo-1985.6c72e5c2.jpg";